import { render, staticRenderFns } from "./RegulatoryLicenseType.vue?vue&type=template&id=75b733b2"
import script from "./RegulatoryLicenseType.vue?vue&type=script&lang=ts"
export * from "./RegulatoryLicenseType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports